import type { FormEvent, KeyboardEvent, KeyboardEventHandler } from 'react';

export type IKeyEventMap = {
  [keyCode: number]: KeyboardEventHandler<HTMLElement>;
};

export const createKeyEventHandler =
  (actions: IKeyEventMap, preventDefault = false) =>
  (e: KeyboardEvent<HTMLElement>) => {
    Object.keys(actions).some((k) => {
      const key = Number(k);
      if (e.which === key) {
        if (preventDefault) {
          e.preventDefault();
        }
        actions[key](e);
        return true;
      }
      return false;
    });
  };

export const createStringChangeHandler = (handler: (value: string) => void) => (event: FormEvent<HTMLElement>) =>
  handler((event.target as HTMLInputElement).value);

export const createBooleanChangeHandler = (handler: (value: boolean) => void) => (event: FormEvent<HTMLElement>) =>
  handler((event.target as HTMLInputElement).checked);
